// Blog Search Autocomplete
function initBlogSearch() {
  const searchInput = document.getElementById("blog-search-input");
  const resultsContainer = document.getElementById("blog-search-results");
  const resultsList = document.getElementById("search-results-list");
  const loadingEl = document.getElementById("search-loading");
  const noResultsEl = document.getElementById("search-no-results");

  if (!searchInput || !resultsContainer) return;

  // Verifica se blogSearch está definido
  if (typeof blogSearch === "undefined") {
    console.error(
      "blogSearch não está definido. Verifique se wp_localize_script está funcionando."
    );
    return;
  }

  let searchTimeout = null;

  // Função para fazer a busca
  function performSearch(searchTerm) {
    if (searchTerm.length < 2) {
      resultsContainer.classList.add("hidden");
      return;
    }

    // Mostra loading
    resultsContainer.classList.remove("hidden");
    loadingEl.classList.remove("hidden");
    resultsList.innerHTML = "";
    noResultsEl.classList.add("hidden");

    // Faz a requisição AJAX
    const formData = new FormData();
    formData.append("action", "blog_search");
    formData.append("search", searchTerm);
    formData.append("nonce", blogSearch.nonce);

    // Adiciona categoria ativa se houver
    if (typeof window.getActiveCategory === "function") {
      const activeCat = window.getActiveCategory();
      if (activeCat) {
        formData.append("category_id", activeCat);
      }
    }

    fetch(blogSearch.ajaxurl, {
      method: "POST",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        loadingEl.classList.add("hidden");

        if (data.success && data.data.posts && data.data.posts.length > 0) {
          displayResults(data.data.posts);
        } else {
          noResultsEl.classList.remove("hidden");
        }
      })
      .catch((error) => {
        console.error("Erro na busca:", error);
        loadingEl.classList.add("hidden");
        noResultsEl.classList.remove("hidden");
      });
  }

  // Função para exibir os resultados
  function displayResults(posts) {
    resultsList.innerHTML = "";

    posts.forEach((post) => {
      const resultItem = document.createElement("a");
      resultItem.href = post.url;
      resultItem.className =
        "flex items-start gap-4 p-4 hover:bg-gray-50 transition-colors duration-200 border-b border-gray-100 last:border-0 no-underline";

      let thumbnailHtml = "";
      if (post.thumbnail) {
        thumbnailHtml = `
          <div class="flex-shrink-0 w-16 h-16 rounded-lg overflow-hidden bg-gray-200">
            <img src="${post.thumbnail}" alt="${post.title}" class="w-full h-full object-cover" loading="lazy">
          </div>
        `;
      } else {
        thumbnailHtml = `
          <div class="flex-shrink-0 w-16 h-16 rounded-lg overflow-hidden bg-purple-100 flex items-center justify-center">
            <span class="text-2xl">📄</span>
          </div>
        `;
      }

      resultItem.innerHTML = `
        ${thumbnailHtml}
        <div class="flex-1 min-w-0">
          <h3 class="text-base font-semibold text-gray-900 mb-1 line-clamp-2">${post.title}</h3>
          <p class="text-sm text-gray-600 mb-2 line-clamp-2">${post.excerpt}</p>
          <span class="text-xs text-gray-500">${post.date}</span>
        </div>
      `;

      resultsList.appendChild(resultItem);
    });
  }

  // Event listener para o input
  searchInput.addEventListener("input", (e) => {
    const searchTerm = e.target.value.trim();

    // Limpa o timeout anterior
    if (searchTimeout) {
      clearTimeout(searchTimeout);
    }

    // Define um novo timeout (debounce de 500ms)
    searchTimeout = setTimeout(() => {
      performSearch(searchTerm);
    }, 500);
  });

  // Fecha os resultados ao clicar fora
  document.addEventListener("click", (e) => {
    if (
      !searchInput.contains(e.target) &&
      !resultsContainer.contains(e.target)
    ) {
      resultsContainer.classList.add("hidden");
    }
  });

  // Reabre os resultados ao focar no input (se já houver busca)
  searchInput.addEventListener("focus", () => {
    if (
      searchInput.value.trim().length >= 2 &&
      resultsList.children.length > 0
    ) {
      resultsContainer.classList.remove("hidden");
    }
  });
}

export { initBlogSearch };
